import axios from "axios";
import { userActions } from "./_actions";
const getBaseurl = () => {
  if (window?.location?.href) {
    const url = window?.location?.href;
    const firstDotIndex = url.indexOf(".");
    const valueBeforeFirstDot = url.substring(0, firstDotIndex);
    const urlDomain = valueBeforeFirstDot + `-login.edusity.com`;
    return urlDomain;
  }
};
const axiosInstance = axios.create({
  baseURL: getBaseurl(),
  headers: { "Content-Type": "application/json" },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("token"));
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use((response) => {
  if (
    response.data.errorCode &&
    response.status === 200 &&
    response.data.error === "Please log in"
  ) {
    userActions.logout();
    window.location.reload(true);
  } else {
    return response;
  }
});

export default axiosInstance;
